import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreIconVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.58333 5.83464C10.7292 5.83464 11.6667 4.89714 11.6667 3.7513C11.6667 2.60547 10.7292 1.66797 9.58333 1.66797C8.4375 1.66797 7.5 2.60547 7.5 3.7513C7.5 4.89714 8.4375 5.83464 9.58333 5.83464Z",
			fill: "#EFEEF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.58333 7.91797C8.4375 7.91797 7.5 8.85547 7.5 10.0013C7.5 11.1471 8.4375 12.0846 9.58333 12.0846C10.7292 12.0846 11.6667 11.1471 11.6667 10.0013C11.6667 8.85547 10.7292 7.91797 9.58333 7.91797Z",
			fill: "#EFEEF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 16.2513C7.5 15.1055 8.4375 14.168 9.58333 14.168C10.7292 14.168 11.6667 15.1055 11.6667 16.2513C11.6667 17.3971 10.7292 18.3346 9.58333 18.3346C8.4375 18.3346 7.5 17.3971 7.5 16.2513Z",
			fill: "#EFEEF0"
		})
	]
});
export default SvgMoreIconVertical;
